import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enumLabel',
    standalone: true
})
export class EnumLabelPipe implements PipeTransform {

    transform(value: string | null | undefined): string {
        if (!value) return 'Unknown';

        // Convert 'IN_PRODUCTION' or 'start' => 'In Production' / 'Start'
        return value
            .split('_')
            .filter(part => part.length > 0)
            .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
            .join(' ');
    }
}
